import axios from 'axios'

export default {
    async create(model) {
        return await axios.post(`role`, model)
    },
    async fetchById(id) {
        return await axios.get(`role/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`role?q=${query}&page=${page}`)
    },

    async fetchAll() {
        return await axios.get(`role/all`)
    },
    async update(id, model) {
        return await axios.put(`role/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`role/${id}`)
    },
    async exportExcel(query){
        return await axios.get(`role/export-excel?q=${query}`)
    },
    async exportSampleExcel(labels) {
        return await axios.post(`role/export-sample-excel`, {
            labels: labels
        });
    },
    async upload(params){
        return await axios.post(`role/import-excel`, params)
    },
    async exportExcelCSV(filters_r){
        return await axios.get(`role/export-excel-csv?q=${filters_r}`)
    },
    
}
